// src/components/ConfirmDeleteModal.js
import React from 'react';
import { FaTrash, FaTimes } from 'react-icons/fa';
import './ConfirmDeleteModal.css';

const ConfirmDeleteModal = ({ isOpen, title, message, onConfirm, onCancel, isLoading = false }) => {
  if (!isOpen) return null;

  return (
    <div className="confirm-delete-overlay">
      <div className="confirm-delete-modal">
        <button className="modal-close-x" onClick={onCancel} disabled={isLoading}>
          <FaTimes />
        </button>

        <div className="modal-icon">
          <FaTrash />
        </div>

        <h2 className="modal-title">{title || '¿Eliminar elemento?'}</h2>
        
        <p className="modal-message">
          {message || '¿Estás seguro de que deseas eliminar este elemento? Esta acción no se puede deshacer.'}
        </p>

        <div className="modal-actions">
          <button 
            className="btn-cancel" 
            onClick={onCancel}
            disabled={isLoading}
          >
            Cancelar
          </button>
          <button 
            className="btn-delete" 
            onClick={onConfirm}
            disabled={isLoading}
          >
            {isLoading ? 'Eliminando...' : 'Eliminar'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDeleteModal;
